var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},_vm._l((_vm.items),function(item){return _c('div',{key:item.slug,staticClass:"press-item-wrapper"},[_c('h3',[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"item-details",domProps:{"innerHTML":_vm._s(item.text)}}),_c('router-link',{staticClass:"link",attrs:{"to":{
        name: 'media-subsection',
        params: {
          section: 'press',
          subsection: item.slug,
          locale: _vm.$i18n.locale
        }
      }},nativeOn:{"click":function($event){return _vm.$emit('scrollToTop')}}},[_vm._v(_vm._s(_vm.$t("media.readMore"))+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }